import { useEffect, useState } from 'react';
import { GridRowModes, GridToolbarContainer, useGridApiRef } from '@mui/x-data-grid-premium';
import { Field, FieldArray, useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { Box, Paper } from '@mui/material';

import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers, AddButtonUi, DatagridPremiumUi } from '../../Interface';
import productionService from '../../../service/production.service';
import ProductionIssueDialog from './ProductionIssueDialog';

const EditToolbar = (props) => {
  const { disabled, setDialogOpen } = props;

  const handleClick = async () => {
    setDialogOpen(true);
  };

  return (
    <GridToolbarContainer>
      <AddButtonUi disabled={disabled} onClick={handleClick} />
    </GridToolbarContainer>
  );
};

const ProductionIssues = (props) => {
  const { selectedValues, disabled } = props;
  const [reports, setReports] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false);

  const columns = dataGridPremiumColumns([
    {
      field: 'docNumber',
      headerName: 'Biz. szám',
      type: 'string',
      valueGetter: (_data, row) => row.doc.docNum,
    },
    {
      field: 'itemCode',
      headerName: 'Cikkszám',
      type: 'string',
    },
    {
      field: 'itemName',
      headerName: 'Cikknév',
      type: 'string',
    },
    {
      field: 'qty',
      headerName: 'Mennyiség',
      type: 'string',
      filterable: false,
    },
    {
      field: 'quantityUnitCode',
      headerName: 'Me.',
      type: 'string',
      filterable: false,
      sortable: false,
    },
  ]);

  useEffect(() => {
    setReports(selectedValues?.issues ?? []);
  }, [selectedValues]);

  return (
    <>
      <Box sx={{ overflowX: 'auto' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Paper elevation={2} sx={{ overflow: 'hidden', boxShadow: 3, borderRadius: 2, width: '100%' }}>
            <DatagridPremiumUi
              datagridIdentifier={DataGridIdentifiers.ProductionIssue}
              height={480}
              columns={columns}
              rows={reports}
              slots={{
                toolbar: EditToolbar,
              }}
              slotProps={{
                toolbar: {
                  disabled,
                  setDialogOpen,
                },
              }}
              headerFilters={false}
              getRowHeight={() => 'auto'}
              getRowId={(row) => `${row.docId}_${row.lineNum}`}
            />
          </Paper>
        </Box>
      </Box>
      <ProductionIssueDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSave={(data) => {
          setReports((prev) => [...prev, data]);
          setDialogOpen(false);
        }}
        {...props}
      />
    </>
  );
};

export default ProductionIssues;
